import React from "react";
import { useEffect, useState } from "react";
import { useLogin, useRegister } from "../../../hooks/apis/auth";
import { useAuthStore } from "../../../store/useUserStore";
import { useNavigate } from 'react-router-dom';

function OTPModal(props) {
  const navigate = useNavigate();
  const { authData, removeAuthData } = useAuthStore((state) => state);
  
  const {
    mutate: mutateLogin,
    isLoading: isLoadingLogin,
    error: errorLogin,
    isError: isErrorLogin,
    isSuccess: successLogin,
  } = useLogin();

  const {
    mutate: mutateRegister,
    isLoading: isLoadingRegister,
    error: errorRegister,
    isError: isErrorRegister,
    isSuccess: successRegister,
  } = useRegister();

  const [inputError, setInputError] = useState("");

  //Close modal handle
  const handleClose = () =>{
    document.querySelector('.otp_modal').classList.remove('active');
    document.querySelector('.modal').classList.remove('active');
  }

  //Handle OTP code

  const handleOTP = () => {
    let otp_error = [];
    const otpCode = document.querySelector("#otpLogin").value;
    const phoneNumber = document.querySelector("#loginPhone").value;

    document.querySelector(".errors").innerHTML = "";

    if (otpCode === "" || otpCode === null) {
      otp_error.push({ message: "لطفا کد تایید را وارد کنید" });
    }
    if (isNaN(otpCode)) {
      otp_error.push({
        message: "لطفا کد تایید را با اعداد انگلیسی وارد کنید",
      });
    }

    if (otp_error.length > 0) {
      //Show errors
      let nodes = otp_error.map((err) => {
        let p = document.createElement("p");
        p.textContent = err.message;
        return p;
      });
      document.querySelector(".errors").append(...nodes);
    } else {
      //Call API
      if (authData.actionType === "login") {
        mutateLogin({ mobile: phoneNumber, login_code: otpCode });
      } else {
        mutateRegister({
          name: `${authData.firstName} ${authData.lastName}`,
          mobile: authData.phoneNumber,
          gender: authData.gender,
          login_code: otpCode,
        });
      }
    }

    otp_error = [];
  };

  useEffect(() => {
    if (isErrorLogin || isErrorRegister) {
      setInputError("کد تایید وارد شده درست نیست");
    }
  }, [isErrorLogin,isErrorRegister]);

  useEffect(() => {
    if (successRegister || successLogin) {
      removeAuthData();
      // redirect to route after register or login
      navigate('/profile');
      document.querySelector('.otp_modal').classList.remove('active');
      document.querySelector('.modal').classList.remove('active');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successRegister, successLogin]);

  return (
    <>
      <div
        style={{ width: "600px" }}
        className={props.showPop ? "popup active otp_modal" : "popup otp_modal"}
      >
        <span onClick={handleClose} className="close position-absolute" style={{top:"15px",right:"15px",cursor:"pointer"}}>
          <svg width="28" height="28" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path fill="#676767" fillRule="evenodd" d="M11.2929,3.29289 C11.6834,2.90237 12.3166,2.90237 12.7071,3.29289 C13.0976,3.68342 13.0976,4.31658 12.7071,4.70711 L9.41421,8 L12.7071,11.2929 C13.0976,11.6834 13.0976,12.3166 12.7071,12.7071 C12.3166,13.0976 11.6834,13.0976 11.2929,12.7071 L8,9.41421 L4.70711,12.7071 C4.31658,13.0976 3.68342,13.0976 3.29289,12.7071 C2.90237,12.3166 2.90237,11.6834 3.29289,11.2929 L6.58579,8 L3.29289,4.70711 C2.90237,4.31658 2.90237,3.68342 3.29289,3.29289 C3.68342,2.90237 4.31658,2.90237 4.70711,3.29289 L8,6.58579 L11.2929,3.29289 Z" />
          </svg>
        </span>
        <img
          src="/images/check-otp.svg"
          className="img-fluid mx-auto d-block mb-4"
          width="180"
          style={{ marginTop: "-40px" }}
          alt="phone-level"
        />
        <p className="text-center text-white mb-4" id="title_form">
          لطفا کد تایید ارسال شده را وارد کنید
        </p>
        <p
          style={{ width: "85%" }}
          className="login-phone position-relative m-auto mb-5 d-flex align-items-center justify-content-between"
        >
          <input
            className="w-75 border border-secondary rounded text-white"
            type="text"
            name="otpLogin"
            id="otpLogin"
            placeholder="کد تایید"
            style={{
              background: "#454545",
              padding: "0 10px 0 10px",
              outline: "0",
              letterSpacing: "3px",
              fontSize: "15px",
            }}
            onChange={() => {
              setInputError("");
            }}
          />
          <input
            onClick={handleOTP}
            className="rounded text-white"
            style={{
              width: "24%",
              border: "1px solid #ed1c24",
              background: "#ed1c24",
            }}
            type="button"
            name="otpSubmit"
            id="otpSubmit"
            value="تایید کد"
          />
        </p>
        <div
          className="errors text-center text-warning position-absolute bottom-0 m-auto"
          style={{ width: "93%" }}
        >
          {inputError}
        </div>
        <div className={isLoadingLogin || isLoadingRegister ? "active loading" : "loading"}>
          <img src="/images/loading.svg" className="img-fluid" alt="loading" />
        </div>
      </div>
    </>
  );
}

export default OTPModal;
